export enum EgressOptionType {
  Kusto = 'Kusto',
  Others = 'Others'
}
